import { render, staticRenderFns } from "./highlightsNews-dist.vue?vue&type=template&id=c8607e60&scoped=true&"
import script from "./highlightsNews-dist.vue?vue&type=script&lang=js&"
export * from "./highlightsNews-dist.vue?vue&type=script&lang=js&"
import style0 from "./highlightsNews-dist.vue?vue&type=style&index=0&id=c8607e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8607e60",
  null
  
)

export default component.exports